import * as React from "react";
import { useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Tooltip from "@mui/material/Tooltip";

function FilterButton(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [isRolesOpen, setIsRolesOpen] = useState(false);
  const filterList = [
    "Scheduled Only",
    "Has Availability",
    "Availability Conflicts",
    "Schedule Violations",
  ];

  const selectedFilters = Array.isArray(props.filtered)
    ? props.filtered
    : props.filtered
    ? [props.filtered]
    : [];

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      setIsRolesOpen(false);
    }
  };

  const toggleRolesDropdown = (event) => {
    event.stopPropagation();
    setIsRolesOpen(!isRolesOpen);
  };

  const toggleFilterItem = (item) => {
    const next = selectedFilters.includes(item)
      ? selectedFilters.filter((x) => x !== item)
      : [...selectedFilters, item];
    props.filterTeam(next);
  };

  const handleRoleToggle = (roleId, event) => {
    event.stopPropagation();
    props.setSelectedRolesForFiltering((prev) =>
      prev.includes(roleId)
        ? prev.filter((id) => id !== roleId)
        : [...prev, roleId]
    );
  };

  const cancelFilter = () => {
    props.setSelectedRolesForFiltering([]);
    props.filterTeam([]);
  };

  const dropdownRef = React.useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
      setIsRolesOpen(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const activeFilterCount =
    selectedFilters.length + (props.selectedRolesForFiltering?.length || 0);
  const hasActiveFilter = activeFilterCount > 0;

  return (
    <div className="relative">
      <div className="flex items-center">
        <div
          className="relative group"
          onClick={props.showWarnings ? undefined : toggleDropdown}
          ref={dropdownRef}
        >
          {props.toolbarMode ? (
            <Button
              data-help-id="schedule-filter-menu"
              disabled={props.showWarnings}
              disableRipple
              startIcon={
                <FilterAltOutlinedIcon
                  sx={{
                    fontSize: 18,
                    color: hasActiveFilter ? "#6d28d9" : "#1e293b",
                  }}
                />
              }
              endIcon={
                <KeyboardArrowDownIcon
                  sx={{ fontSize: 20, color: "#64748b" }}
                />
              }
              sx={{
                textTransform: "none",
                borderRadius: "8px",
                border: "1px solid transparent",
                color:
                  !props.showWarnings && hasActiveFilter ? "#6d28d9" : "#1e293b",
                backgroundColor: "transparent",
                px: 1.75,
                py: 1,
                fontSize: 14,
                fontWeight: 500,
                minWidth: 0,
                lineHeight: 1.4,
                "& .MuiButton-startIcon": { marginRight: "8px" },
                "& .MuiButton-endIcon": { marginLeft: "4px" },
                "&:hover": {
                  backgroundColor: "#e2e8f0",
                  borderColor: "transparent",
                },
                "&.Mui-disabled": {
                  backgroundColor: "transparent",
                  borderColor: "transparent",
                  color: "#94a3b8",
                  "& .MuiSvgIcon-root": {
                    color: "#94a3b8",
                  },
                },
              }}
            >
              Filter
              {hasActiveFilter && (
                <span
                  style={{
                    marginLeft: 8,
                    backgroundColor: "#ede9fe",
                    color: "#6d28d9",
                    borderRadius: 999,
                    minWidth: 18,
                    height: 18,
                    padding: "0 6px",
                    fontSize: 11,
                    fontWeight: 600,
                    lineHeight: 1,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {activeFilterCount}
                </span>
              )}
            </Button>
          ) : (
            <Tooltip title={`${!isOpen ? (props.showWarnings ? "" : "Filter By") : ""}`}>
              <IconButton
                disabled={props.showWarnings}
                style={{
                  color: hasActiveFilter ? "#6d28d9" : undefined,
                }}
                className="group-hover:bg-gray-200 transition"
              >
                <FilterAltIcon />
              </IconButton>
            </Tooltip>
          )}

          {isOpen && (
            <div
              className="absolute left-0 z-30"
              style={{
                top: "calc(100% + 8px)",
                minWidth: 260,
                maxHeight: 600,
                overflowY: "auto",
                backgroundColor: "white",
                border: "1px solid #e2e8f0",
                borderRadius: 8,
                boxShadow: "0 12px 28px rgba(15, 23, 42, 0.12)",
                paddingTop: 4,
                paddingBottom: 4,
              }}
            >
              {/* Existing filter options - Hide in monthly view */}
              {!props.monthlyView && (
                <div
                  style={{
                    padding: "8px 16px 4px",
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                    color: "#94a3b8",
                  }}
                >
                  Filter by
                </div>
              )}
              {!props.monthlyView &&
                filterList.map((item, index) => {
                  const isActive = selectedFilters.includes(item);
                  return (
                    <div
                      className="flex items-center justify-between cursor-pointer"
                      key={index}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleFilterItem(item);
                      }}
                      style={{
                        padding: "8px 16px",
                        backgroundColor: "transparent",
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = "#f8fafc")
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor = "transparent")
                      }
                    >
                      <span
                        style={{
                          fontSize: 14,
                          color: isActive ? "#6d28d9" : "#334155",
                          fontWeight: isActive ? 600 : 400,
                        }}
                      >
                        {item}
                      </span>
                      {isActive && (
                        <CheckIcon
                          style={{ color: "#6d28d9", fontSize: 18 }}
                        />
                      )}
                    </div>
                  );
                })}

              {/* Roles Expandable Section */}
              {!props.monthlyView && (
                <div
                  style={{
                    height: 1,
                    backgroundColor: "#e2e8f0",
                    margin: "4px 0",
                  }}
                />
              )}
              <div>
                {!props.monthlyView && (
                  <div
                    style={{
                      padding: "8px 16px 4px",
                      fontSize: 11,
                      fontWeight: 700,
                      letterSpacing: "0.08em",
                      textTransform: "uppercase",
                      color: "#94a3b8",
                    }}
                  >
                    Roles
                  </div>
                )}
                {!props.monthlyView && (
                  <div
                    className="flex items-center justify-between cursor-pointer"
                    onClick={toggleRolesDropdown}
                    style={{ padding: "8px 16px", backgroundColor: "transparent" }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f8fafc")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    <span
                      style={{
                        fontSize: 14,
                        color: "#334155",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {props.selectedRolesForFiltering?.length > 0
                        ? `${props.selectedRolesForFiltering.length} selected`
                        : "Select roles"}
                    </span>
                    {isRolesOpen ? (
                      <ExpandLessIcon
                        style={{ fontSize: 18, color: "#94a3b8" }}
                      />
                    ) : (
                      <ExpandMoreIcon
                        style={{ fontSize: 18, color: "#94a3b8" }}
                      />
                    )}
                  </div>
                )}

                {(isRolesOpen || props.monthlyView) && (
                  <div>
                    {props.role_names?.map((role) => {
                      const checked = props.selectedRolesForFiltering?.includes(
                        role.id
                      );
                      return (
                        <div
                          key={role.id}
                          className="flex items-center cursor-pointer"
                          onClick={(e) => handleRoleToggle(role.id, e)}
                          style={{
                            padding: props.monthlyView
                              ? "6px 16px"
                              : "6px 16px 6px 32px",
                            backgroundColor: "transparent",
                          }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.backgroundColor = "#f8fafc")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.backgroundColor =
                              "transparent")
                          }
                        >
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={() => {}}
                            className="mr-3 w-4 h-4 rounded pointer-events-none"
                            style={{ accentColor: "#6d28d9" }}
                          />
                          <span
                            style={{
                              fontSize: 14,
                              color: checked ? "#6d28d9" : "#475569",
                              fontWeight: checked ? 600 : 400,
                            }}
                          >
                            {role.role_name}
                          </span>
                        </div>
                      );
                    })}
                    {(!props.role_names || props.role_names.length === 0) && (
                      <div
                        style={{
                          padding: props.monthlyView
                            ? "12px 16px"
                            : "12px 16px 12px 32px",
                          textAlign: "center",
                          color: "#94a3b8",
                          fontSize: 13,
                        }}
                      >
                        No roles available
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Reset footer */}
              <div
                style={{
                  height: 1,
                  backgroundColor: "#e2e8f0",
                  margin: "4px 0",
                }}
              />
              <div
                className="cursor-pointer flex items-center"
                onClick={cancelFilter}
                style={{ padding: "10px 16px", backgroundColor: "transparent" }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#f8fafc")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
              >
                <span style={{ fontSize: 13, color: "#64748b", fontWeight: 500 }}>
                  Reset filters
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default FilterButton;
